module.exports = __webpack_public_path__ + "img/ico_dots--or.606d3596.svg";